const htmlUnsafeCharsReplacementMap: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
};

const xHHUnsafeCharsReplacementMap = Object.keys(
  htmlUnsafeCharsReplacementMap,
).reduce(
  (a, char) => {
    a[char] = `\\x${char.charCodeAt(0).toString(16).toUpperCase()}`;
    return a;
  },
  {} as Record<string, string>,
);

const replaceByMap = (string: string, replacements: Record<string, string>) =>
  [...string].map((char) => replacements[char] || char).join('');

export const escapeForHtml = (string: string) =>
  replaceByMap(string, htmlUnsafeCharsReplacementMap);

export const escapeForJsContext = (string: string) =>
  replaceByMap(string, xHHUnsafeCharsReplacementMap);
